import { Types } from '@store/types';

const initialState = [];

const MerchandiserReducer = (state = initialState, action) => {
	switch (action.type) {
		case Types.STORE_MERCHANDISER_LIST:
			return [...initialState, ...action.payload];
		default:
			return state;
	}
};

export default MerchandiserReducer;
